/* eslint-disable @typescript-eslint/no-explicit-any */
import { AxiosResponse } from 'axios';
import { call, delay, put, takeLatest } from 'redux-saga/effects';

import api from '../../api/api';
import { errorHandling } from '../../api/errorHandling';
import { mapSuccessResponseToState } from '../../api/responseHandling';
import * as commonSagas from '../_common/commonSagas';
import { apiVersion } from '../apiVersion';
import * as resultsSlice from './resultsSlice';
import { ResultPicture } from './resultsSlice';

function* approveResultSaga(props: { type: string; payload: number[] }) {
 try {
  const version = apiVersion.results.approveResult;
  const response: AxiosResponse<any[]> = yield call(
   api.put,
   `/Results/v${version}/approve`,
   props.payload,
  );

  yield put(
   resultsSlice.approveResultSuccess(
    mapSuccessResponseToState(response, 'Result', 'approved'),
   ),
  );
  yield delay(0);
  yield put(resultsSlice.approveResultFinish());
 } catch (error: unknown) {
  yield* errorHandling(error, resultsSlice.approveResultFailure);
 }
}

function* getResultPicturesSaga(props: { type: string; payload: number }) {
 try {
  const version = apiVersion.results.getResultPictures;
  const response: AxiosResponse<ResultPicture[]> = yield call(
   api.get,
   `/Results/v${version}/${props.payload}/pictures`,
  );

  yield put(resultsSlice.getResultPicturesSuccess(response.data));
  yield delay(0);
  yield put(resultsSlice.getResultPicturesFinish());
 } catch (error: unknown) {
  yield* errorHandling(error, resultsSlice.getResultPicturesFailure);
 }
}

export default function* watchResultsaga() {
 yield takeLatest(resultsSlice.getTableStart.type, commonSagas.getTable);
 yield takeLatest(resultsSlice.getItemStart.type, commonSagas.getItem);
 yield takeLatest(resultsSlice.createItemStart.type, commonSagas.createItem);
 yield takeLatest(resultsSlice.updateItemStart.type, commonSagas.updateItem);
 yield takeLatest(resultsSlice.deleteItemStart.type, commonSagas.deleteItem);
 yield takeLatest(
  resultsSlice.getTableStructureStart.type,
  commonSagas.getTableStructure,
 );
 yield takeLatest(
  resultsSlice.getItemDocumentsStart.type,
  commonSagas.getItemDocuments,
 );
 yield takeLatest(
  resultsSlice.uploadItemDocumentsStart.type,
  commonSagas.uploadItemDocuments,
 );
 yield takeLatest(
  resultsSlice.deleteItemDocumentStart.type,
  commonSagas.deleteItemDocument,
 );
 yield takeLatest(
  resultsSlice.getTableExcelStart.type,
  commonSagas.getTableExcel,
 );
 //
 yield takeLatest(resultsSlice.approveResultStart.type, approveResultSaga);
 yield takeLatest(
  resultsSlice.getResultPicturesStart.type,
  getResultPicturesSaga,
 );
}
